<template >
 <v-dialog v-model="show_dialog" :max-width="width">
  <v-card>
    <v-card-title primary-title class="headline info lighten-2">
    	<h2>{{title}}</h2>
    </v-card-title>
    <v-card-text>
      <v-form>     
        <v-select v-if="show_dialog == 'ship_out'"
            v-bind:items="shop_list"
            :error = "!shop_id"
            v-model="shop_id"
            label="请选择目标店铺"
            item-value="_id"
            item-text="cn_name"
            required
            clearable>
            
        </v-select>
        <v-text-field
            label="备注"
            v-model="note"
            :error = "!note"
            required>
            
        </v-text-field>
      </v-form>
    </v-card-text>
    
    <v-card-actions>
    	<v-spacer></v-spacer>
      <v-btn class="btn-" @click.stop="show_dialog=false">取消</v-btn>
      <v-btn
	      :loading="creating"
	      :disabled="creating||!can_do_it()"
	      color="info"
	      @click.native.stop="create_record">
	      确定
	      <span slot="loader" class="custom-loader">
	        Loading...
	      </span>
	  </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>       
        
   
</template>

<script>
import {base_api} from "@/api/base_api"   
import {selectoption} from "@/api/module/select_options"	
export default {
    //template:``,
    name: '',
    props:{
    	width:{
    		type:String,
    		default:'500px'
    	}
    },
    computed:{
    	show_dialog:{
	      get(){
	          return this.$store.state.dialog.show_ship_out_dialog;
	      },
	      set(val){
            if(val == true){
                debugger
                if(this.support_oper.indexOf(this.show_dialog) >=0){
                    return 
                }
            }
            this.$store.commit('SHOW_DIALOG_SHIP_OUT',val)
	      }
	    },
        prodcuts_list(){
            return this.$store.state.products;
        },
        title(){
            switch(this.show_dialog){
                case 'ship_out':
                    return "出库";
                case 'request':
                    return "配货申请";
                case 'destroy':
                    return "报损";
                case 'recv':
                    return "收货";
                case 'pandian':
                    return "盘点";
                default:
                    return this.show_dialog
            }
        }
    },
    methods:{
    	init_value(){
            this.creating = false;
            this.shop_id  = "";
            this.note     = '';
    	},
        can_do_it(){
            if(this.show_dialog == 'ship_out' && (!this.shop_id || !this.note)) return false
            if(!this.note ) return false
            return true;
        },
    	get_shop_list(){
    		console.log("NEED GET SYSUSER LIST");
    		selectoption({oper:'shop',key:"_id",value:"cn_name",type:'obj',skipp:'shop_id'}).then(resp=>{
    			this.shop_list= resp.data;
    		}).catch(err=>{
    			console.log(err);
                debugger
    		})
    	},
        post_data_gen(){
            debugger
            let self   = this;
            let oper   = self.show_dialog;
            let schema = 'ship.php';
            let title  = (oper == 'request')? "配货请求操作成功":"出库成功！";
            let data   = {
                order_id :self.prodcuts_list.order_id,
                note     :self.note,
                to       :self.shop_id,
                items    :self.prodcuts_list.list.map(it=>{return {
                    gid     :it.gid,
                    info    :it.name,
                    num     :it.num,
                    incount :0
                }})
            }

            if(oper =='request'){
                data.node = data.note;
            }
            //gid,nm,count,isnew
            if(oper   == 'recv' || oper == 'pandian'){
                schema = oper + ".php";
                oper  = (oper == 'recv')?'upload':'pandian';
                title  = (oper == 'upload')?'收货成功!':'盘点数据上传成功!';
                data.detail = self.prodcuts_list.list.map(it=>{return {
                    gid     :it.gid,
                    nm      :it.name,
                    count   :it.num,
                    isnew   :it.isnew?true:false
                }})
                delete data.items;
            }
            if(oper != 'ship_out'){
                delete data.shop_id;
            }
            return {oper,schema,data,title};
        },
    	create_record(){
    		console.log("click")
            let self = this;
            if(self.prodcuts_list.list.length == 0){
                return self.$notify({
                        group: 'msgpad',
                        type: 'warn',
                        title: '操作失败！',
                        text: '无待操作商品'
                })
            }

            if(self.support_oper.indexOf(self.show_dialog)<0) return false;
            let {oper,schema,data,title} = self.post_data_gen();
            
            debugger

            // let oper = (self.show_dialog == 'recv'?'upload':self.show_dialog);
            // let oper_title = (oper == 'request')? "配货请求操作成功":"出库成功！";

            // if(self.show_dialog == 'recv') oper_title = "收货成功";

            self.creating = true;
            base_api({//"/recv.php?oper=upload";
                schema,
                method:'post',
                params:{oper},//self.show_dialog
                data
            }).then(doc=>{
                self.$store.commit('PAYINFO_SETTING',{pay_status:1,title})
				self.$notify({
                    group : 'msgpad',
                    type  : 'success',
                    title : '操作成功！',
                    text  : title,
			        duration: 500,
			    })
			    self.show_dialog = false;
			}).catch(err=>{
				self.$notify({
			        group: 'msgpad',
			        type: 'warn',
			        title: '操作失败！',
			        text: '记录创建失败'+   err.response&&err.response.data? err.response.data: err.message
			    })
			}).then(_=>{
				self.creating = false;
			})
    	}
    },
    components:{},
    watch:{
    	show_dialog(val){
    		if(val){
    			this.init_value();
    			if(this.shop_list.length == 0){
    				this.get_shop_list();
    			}
    		}
    	}
    },
    directives: {},
    mounted :function(){
    	if(this.shop_list.length == 0){
    		this.get_shop_list()
    	}
    },
    data () {
      return {
      	creating:false,
        shop_id:null,
        note:'',
		shop_list:[],
        support_oper:['ship_out','request','destroy','recv','pandian']
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_ship_out.vue